import request from '@/utils/request';

// 获取车辆类型曲线
export function getVehicleTypeStatistics(query) {
  return request({
    url: '/netcar/api/dashboard/vehicle-type-statistics',
    method: 'GET',
    data: query
  })
}

// 获取运力数据信息
export function getTransport(query) {
  return request({
    url: '/netcar/api/dashboard/transport',
    method: 'GET',
    data: query
  })
}

// 获取支付占比
export function getPaymentRatio(query) {
  return request({
    url: '/netcar/api/dashboard/payment-ratio',
    method: 'GET',
    data: query
  })
}

// 获取最新五条数据列表
export function getOrderTop(query) {
  return request({
    url: '/netcar/api/dashboard/order-top',
    method: 'GET',
    data: query
  })
}

// 订单统计
export function getOrderStatistics(query) {
  return request({
    url: '/netcar/api/dashboard/order-statistics',
    method: 'GET',
    data: query
  })
}

// 司机在线率
export function getDriverOnlineRate(query) {
  return request({
    url: '/netcar/api/dashboard/driver-online-rate',
    method: 'GET',
    data: query
  })
}

// 获取司机收入
export function getDriverIncome(query) {
  return request({
    url: '/netcar/api/dashboard/driver-income',
    method: 'GET',
    data: query
  })
}

// 获取车型整体收益
export function businessCarIncome(query) {
  return request({
    // url: '/netcar/api/dashboard/business-car-income',
    url: '/netcar/api/dashboard/transport-income',
    method: 'GET',
    data: query
  })
}